/* The orbital ten-stage methodology ring — ported from tools/build.py's
 * orbit_positions() (same angle formula) so the visual is identical to
 * the static build. */
export interface OrbitStage {
  code: string;
  stage: string;
}

function orbitPositions(n: number, radiusPct = 44) {
  const pts: Array<{ x: number; y: number }> = [];
  for (let i = 0; i < n; i++) {
    const angle = (i / n) * 2 * Math.PI - Math.PI / 2;
    pts.push({ x: 50 + radiusPct * Math.cos(angle), y: 50 + radiusPct * Math.sin(angle) });
  }
  return pts;
}

export default function MethodologyOrbit({
  stages,
  activeCode,
  onSelect,
  maxWidth = 620,
  label = 'CYRKIL\nIntelligent\nEnterprise',
}: {
  stages: OrbitStage[];
  activeCode?: string;
  onSelect?: (code: string) => void;
  maxWidth?: number;
  label?: string;
}) {
  const positions = orbitPositions(stages.length);
  return (
    <div className="orbit-stage" style={{ maxWidth }}>
      <div className="orbit-ring" />
      <div className="orbit-ring r2" />
      <div className="orbit-spin">
        {stages.map((s, i) => (
          <div
            key={s.code}
            className={`orbit-node ${s.code === activeCode ? 'is-active' : ''}`}
            style={{ left: `${positions[i].x}%`, top: `${positions[i].y}%` }}
            tabIndex={onSelect ? 0 : undefined}
            role={onSelect ? 'button' : undefined}
            aria-label={`Stage ${i + 1} of ${stages.length}: ${s.stage}`}
            onClick={() => onSelect?.(s.code)}
            onKeyDown={(e) => {
              if (onSelect && (e.key === 'Enter' || e.key === ' ')) onSelect(s.code);
            }}
          >
            <span>{String(i + 1).padStart(2, '0')}</span>
          </div>
        ))}
      </div>
      <div className="orbit-center">
        {label.split('\n').map((line, i) => (
          <span key={i}>
            {line}
            {i < label.split('\n').length - 1 && <br />}
          </span>
        ))}
      </div>
    </div>
  );
}
